module.exports = __webpack_public_path__ + "assets/img/8_1564.31d24192.jpg";